import Vue from 'vue'
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css'
import '../styles/iconfont/iconfont.css';

import CustomUI from '../components/index';
import ErpUI from '../modules/erp/components/index'

Vue.use(ElementUI);
Vue.use(CustomUI);
Vue.use(ErpUI);



// WEBPACK FOOTER //
// ./src/config/installer.js